module.exports = __webpack_public_path__ + "img/20190715153705971.2fb2fd5f.png";